module.exports = __webpack_public_path__ + "img/team-bjoern-heinzelmann.f177f083.jpg";